// extracted by mini-css-extract-plugin
export default {"matchCard":"AssignClientModal_matchCard__GlOlo"};